import React from 'react'
import Image from '../UIComponent/Image'
import Button from '../UIComponent/Button'
import './noncarousel-banner.scss'

export default function NonCarouselBanner(prop) {
  const bannerImage = prop.ImageSrc
  const bannerImageAltText = prop.imageAlt
  const bannerHading = prop.heading
  const bannerSubHading = prop.Subheading
  const bannerSubHeading2 = prop.footNote
  const isBookAppointmentBtnEnable = prop.btnVisibility
  const mobileImageSrc = prop.mobImageSrc
  console.log(isBookAppointmentBtnEnable)
  return (
    <div className="non-carousel-banner">
      <Image
        imageSrc={bannerImage}
        imageAltimageAltText={bannerImageAltText}
        imageClass="w-100"
        mobileImageSrc={mobileImageSrc}
      ></Image>
      <div className="banner-content">
        <span className="heading">{bannerHading}</span>
        <span className="para">{bannerSubHading}</span>
        <span className="para2">{bannerSubHeading2}</span>
        <>
          {isBookAppointmentBtnEnable === false ? (
            ''
          ) : (
            <Button
              primaryButton={true}
              buttonClickHandler={prop.buttonOnclick}
            >
              Book Appointment
            </Button>
          )}
        </>
      </div>
    </div>
  )
}
